import { render, staticRenderFns } from "./LifeStyleForm.vue?vue&type=template&id=e7c28c22"
import script from "./LifeStyleForm.vue?vue&type=script&lang=js"
export * from "./LifeStyleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports